import React from 'react'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import * as styles from './products.module.scss'


const Products = ({ products }) => {
    if (products) {
        return (
            <SlideinWrap tagName="table" className={styles.products}>
                <tbody>
                    {products.map((product, i) => (
                        <SlideinItem tagName="tr" delay={i*100} key={i}>
                            <td data-item-id={product.id} data-item-display="1">
                                <a href={product.url} target="_blank" rel="noopener noreferrer">
                                    <div>
                                        <div className={styles.nameWrapper}>
                                            {product.name && (
                                                <span className={styles.name}>{product.name}</span>
                                            )}
                                            {product.brand && (
                                                <span className={styles.brand}>{product.brand}</span>
                                            )}
                                        </div>

                                        {product.price && (
                                            <span className={styles.price}>¥{product.price.toLocaleString()}<span className={styles.tax}>（税込）</span></span>
                                        )}
                                    </div>

                                    {product.url && (
                                        <span className={styles.buy}>BUY</span>
                                    )}
                                </a>
                            </td>
                        </SlideinItem>
                    ))}
                </tbody>
            </SlideinWrap>
        )
    } else {
        return null
    }
}

export default Products